import {
  KebabHorizontalIcon,
  PencilIcon,
  PlusIcon,
  TrashIcon,
} from "@primer/octicons-react";
import {
  ActionList,
  ActionMenu,
  Box,
  IconButton,
  useConfirm
} from "@primer/react";
import { useEffect, useState } from "react";
import { formApi } from "../../api/formApi";
import { trangThaiPhuHuynhApi } from "../../api/trangThaiPhuHuynhApi";
import TextTranslated from "../../components/text";
import Button from "../../components/ui/button";
import DataTable from "../../components/ui/data-table";
import { useCommonContext } from "../../contexts/common";
import { NotifyHelper } from "../../helpers/toast";
import { IForm } from "../../models/response/form/IForm";
import TrangThaiHocSinhDetailModal from "./TruongDetailModal";
import { ITruong } from "../../models/response/truong/ITruong";
import { truongApi } from "../../api/truongApi";
import { useParams } from "react-router-dom";

const Truong = () => {
  const { tab } = useParams();

  const [isShowModal, setIsShowModal] = useState(false);
  const [isShowDetailModalDangKy, setIsShowDetailModalDangKy] = useState(false);

  const [selectedId, setSelectedId] = useState(0);
  const [truongs, setTruongs] = useState<
    ITruong[]
  >([]);
  const [tsForms, setTsForms] = useState<IForm[]>([]);
  const { translate } = useCommonContext();
  const [isSaving, setIsSaving] = useState(false);
  const confirm = useConfirm();

  useEffect(() => {
    handleReloadAsync();
  }, []);
  const handleReloadAsync = async () => {
    const res = await truongApi.selectAll();
    if (res.is_success) {
      setTruongs(res.data);
    } else {
      NotifyHelper.Error(res.message ?? "");
    }
  };

  const handeDelete = async (id: number) => {
    if (
      await confirm({
        content: "Bạn có chắc chắn muốn xóa trường này?",
        title: "Lưu ý",
        cancelButtonContent: "Không xóa",
        confirmButtonContent: "Xóa trường",
        confirmButtonType: "danger",
      })
    ) {
      const res = await truongApi.delete(id);
      if (res.is_success) {
        NotifyHelper.Success("Success");
        handleReloadAsync();
      } else {
        NotifyHelper.Error(res.message ?? "");
      }
    }
  };
  return (
    <Box sx={{ p: 3 }}>
      <DataTable
        height={`${window.innerHeight - 250}px`}
        columns={[
          {
            id: "cmd",
            width: "50px",
            caption: "#",
            align: "center",
            cellRender: (data: ITruong) => {
              return (
                <ActionMenu>
                  <ActionMenu.Anchor>
                    <IconButton
                      icon={KebabHorizontalIcon}
                      variant="invisible"
                      aria-label="Open column options"
                    />
                  </ActionMenu.Anchor>

                  <ActionMenu.Overlay>
                    <ActionList>
                      <ActionList.Item
                        onSelect={() => {
                          // dispatch(actions.soDiem.soDiemList.changeEditingData(item))
                          setIsShowModal(true);
                          if (data.id !== undefined) {
                            setSelectedId(data.id);
                          }                        }}
                      >
                        <ActionList.LeadingVisual>
                          <PencilIcon />
                        </ActionList.LeadingVisual>
                        <TextTranslated value="Base.Label.Edit" />
                      </ActionList.Item>
                      <ActionList.Divider />
                      <ActionList.Item
                        variant="danger"
                        onSelect={() => {
                          if (data.id !== undefined) {
                            handeDelete(data.id);
                          }
                        }}
                      >
                        <ActionList.LeadingVisual>
                          <TrashIcon />
                        </ActionList.LeadingVisual>
                        <TextTranslated value="Base.Label.Delete" />
                      </ActionList.Item>
                    </ActionList>
                  </ActionMenu.Overlay>
                </ActionMenu>
              );
            },
          },
          {
            dataField: "ma_truong",
            width: "auto",
            caption: `Mã trường`,
            cellRender: (data: ITruong) => {
              return (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "baseline",
                    whiteSpace: "nowrap",
                  }}
                >
                  {data.ma_truong}
                </Box>
              );
            },
          },
          {
            dataField: "ten_truong",
            width: "auto",
            isMainColumn: true,
            caption: `Tên trường`,
            cellRender: (data: ITruong) => {
              return (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "baseline",
                    whiteSpace: "nowrap",
                  }}
                >
                  {data.ten_truong || "..."}
                </Box>
              );
            },
          },
          {
            dataField: "ten_truong_tbtp",
            width: "auto",
            caption: `Tên trường TBTP `,
            cellRender: (data: ITruong) => {
              return (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "baseline",
                    whiteSpace: "nowrap",
                  }}
                >
                  {data.ten_truong_tbtp || "..."}
                </Box>
              );
            },
          },
          {
            dataField: "viet_tat",
            width: "auto",
            caption: `Viết tắt `,
            cellRender: (data: ITruong) => {
              return (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "baseline",
                    whiteSpace: "nowrap",
                  }}
                >
                  {data.viet_tat || "..."}
                </Box>
              );
            },
          },
          {
            dataField: "dien_thoai",
            width: "auto",
            caption: `Điện thoại `,
            cellRender: (data: ITruong) => {
              return (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "baseline",
                    whiteSpace: "nowrap",
                  }}
                >
                  {data.dien_thoai || "..."}
                </Box>
              );
            },
          },
          {
            dataField: "may_le",
            width: "auto",
            caption: `Máy lẻ `,
            cellRender: (data: ITruong) => {
              return (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "baseline",
                    whiteSpace: "nowrap",
                  }}
                >
                  {data.may_le || "..."}
                </Box>
              );
            },
          },
          {
            dataField: "so_tk",
            width: "auto",
            caption: `Số tài khoản `,
            cellRender: (data: ITruong) => {
              return (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "baseline",
                    whiteSpace: "nowrap",
                  }}
                >
                  {data.so_tk || "..."}
                </Box>
              );
            },
          },
          {
            dataField: "ten_tk",
            width: "auto",
            caption: `Tên tài khoản `,
            cellRender: (data: ITruong) => {
              return (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "baseline",
                    whiteSpace: "nowrap",
                  }}
                >
                  {data.ten_tk || "..."}
                </Box>
              );
            },
          },
          {
            dataField: "ngan_hang",
            width: "auto",
            caption: `Ngân hàng `,
            cellRender: (data: ITruong) => {
              return (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "baseline",
                    whiteSpace: "nowrap",
                  }}
                >
                  {data.ngan_hang || "..."}
                </Box>
              );
            },
          },
          {
            dataField: "email",
            width: "auto",
            caption: `Email `,
            cellRender: (data: ITruong) => {
              return (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "baseline",
                    whiteSpace: "nowrap",
                  }}
                >
                  {data.email || "..."}
                </Box>
              );
            },
          },
          {
            dataField: "dia_chi_truong",
            width: "auto",
            caption: `Địa chỉ `,
            cellRender: (data: ITruong) => {
              return (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "baseline",
                    whiteSpace: "nowrap",
                  }}
                >
                  {data.dia_chi_truong || "..."}
                </Box>
              );
            },
          },
        ]}
        data={truongs}
        title="Trường"
        subTitle={`${translate("Base.Label.TotalCount")}: ${truongs.length
          }`}
        searchEnable
        actionComponent={
          <>
            <Button
              text={translate('Base.Label.Create')}
              leadingVisual={PlusIcon}
              variant="primary"
              size="medium"
              onClick={() => {
                setIsShowModal(true);
                setSelectedId(0);
              }}
            />
          </>
        }
      />
      {isShowModal && (
        <TrangThaiHocSinhDetailModal
          id={selectedId}
          onClose={() => {
            setIsShowModal(false);
          }}
          onSuccess={() => {
            handleReloadAsync();
            setIsShowModal(false);
          }}
        />
      )}
    </Box>
  );
};

export default Truong;
